import type { CarType$options } from '$houdini';
import * as m from '$paraglide/messages';

const carTypeLabel: Record<CarType$options, () => string> = {
	CITY: m.itinerary__options__car_type__city,
	COMPACT: m.itinerary__options__car_type__compact,
	SPORTS: m.itinerary__options__car_type__sports,
	SUV: m.itinerary__options__car_type__suv,
	SALOON: m.itinerary__options__car_type__saloon,
};

export function carTypes(type: CarType$options): string {
	return carTypeLabel[type]();
}
